import { CommonEnums } from '../../common.enums';

export class DxMp {
    dxMp_Id: number;
    layer_Id: number;
    nm: string;
    description: string;
    ver: string;
    nativeDbTyp_Id: number;
    reusableFlag: string;
    valid_Cd: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    conn_Id: number;
    conn_Nm: string;
    debugFlg: string;
    conn_Fldr_Id: number;
    tform_Valid_Cd: string;
    streamingFlg: string;
    spark_dsa: string;
    type: string;
    gen_Tab_Valid_Cd: string;
    dprm_Tab_Valid_Cd: string;
    sprm_Tab_Valid_Cd: string;
    multiSourceFlg: string;
    dataConnectService_Id: number;
    dataConnectService_Nm: string;

    constructor() {
        this.setDefault();
    }

    setDefault() {
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.layer_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.nativeDbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.reusableFlag = CommonEnums.reusableFlag.NO;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Id = CommonEnums.defaults.LONG_VAL;
        this.conn_Nm = CommonEnums.defaults.STRING_EMPTY;
        this.debugFlg = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.tform_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.streamingFlg = CommonEnums.defaults.STRING_EMPTY;
        this.spark_dsa = CommonEnums.defaults.STRING_EMPTY;
        this.type = CommonEnums.defaults.STRING_EMPTY;
        this.gen_Tab_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dprm_Tab_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.sprm_Tab_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.multiSourceFlg = CommonEnums.defaults.STRING_EMPTY;
        this.dataConnectService_Id = CommonEnums.defaults.LONG_VAL;
        this.dataConnectService_Nm = CommonEnums.defaults.STRING_EMPTY;
    }

    getPrimaryKey(): string {
        return this.dxMp_Id.toString();
    }

    static parse(dxMpTmp: DxMp): DxMp {
        let dxMp: DxMp = new DxMp();
        dxMp.copyFrom(dxMpTmp);
        return dxMp;
    }

    copy(): DxMp {
        let dxMpTmp: DxMp = new DxMp();

        dxMpTmp.dxMp_Id = this.dxMp_Id;
        dxMpTmp.layer_Id = this.layer_Id;
        dxMpTmp.nm = this.nm;
        dxMpTmp.description = this.description;
        dxMpTmp.ver = this.ver;
        dxMpTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        dxMpTmp.reusableFlag = this.reusableFlag;
        dxMpTmp.valid_Cd = this.valid_Cd;
        dxMpTmp.updateBy = this.updateBy;
        dxMpTmp.lastUpdateBy = this.lastUpdateBy;
        dxMpTmp.updateDt = this.updateDt;
        dxMpTmp.change_Ind = this.change_Ind;
        dxMpTmp.error_Cd = this.error_Cd;
        dxMpTmp.error_Msg = this.error_Msg;
        dxMpTmp.conn_Id = this.conn_Id;
        dxMpTmp.conn_Nm = this.conn_Nm;
        dxMpTmp.debugFlg = this.debugFlg;
        dxMpTmp.conn_Fldr_Id = this.conn_Fldr_Id;
        dxMpTmp.tform_Valid_Cd = this.tform_Valid_Cd;
        dxMpTmp.streamingFlg = this.streamingFlg;
        dxMpTmp.spark_dsa = this.spark_dsa;
        dxMpTmp.type = this.type;
        dxMpTmp.gen_Tab_Valid_Cd = this.gen_Tab_Valid_Cd;
        dxMpTmp.dprm_Tab_Valid_Cd = this.dprm_Tab_Valid_Cd;
        dxMpTmp.sprm_Tab_Valid_Cd = this.sprm_Tab_Valid_Cd;
        dxMpTmp.multiSourceFlg = this.multiSourceFlg;
        dxMpTmp.dataConnectService_Id = this.dataConnectService_Id;
        dxMpTmp.dataConnectService_Nm = this.dataConnectService_Nm;
        return dxMpTmp;
    }

    copyFrom(dxMpTmp: DxMp): void {
        this.dxMp_Id = dxMpTmp.dxMp_Id;
        this.layer_Id = dxMpTmp.layer_Id;
        this.nm = dxMpTmp.nm;
        this.description = dxMpTmp.description;
        this.ver = dxMpTmp.ver;
        this.nativeDbTyp_Id = dxMpTmp.nativeDbTyp_Id;
        this.reusableFlag = dxMpTmp.reusableFlag;
        this.valid_Cd = dxMpTmp.valid_Cd;
        this.updateBy = dxMpTmp.updateBy;
        this.lastUpdateBy = dxMpTmp.lastUpdateBy;
        this.updateDt = dxMpTmp.updateDt;
        this.change_Ind = dxMpTmp.change_Ind;
        this.error_Cd = dxMpTmp.error_Cd;
        this.error_Msg = dxMpTmp.error_Msg;
        this.conn_Id = dxMpTmp.conn_Id;
        this.conn_Nm = dxMpTmp.conn_Nm;
        this.debugFlg = dxMpTmp.debugFlg;
        this.conn_Fldr_Id = dxMpTmp.conn_Fldr_Id;
        this.tform_Valid_Cd = dxMpTmp.tform_Valid_Cd;
        this.streamingFlg = dxMpTmp.streamingFlg;
        this.spark_dsa = dxMpTmp.spark_dsa;
        this.type = dxMpTmp.type;
        this.gen_Tab_Valid_Cd = dxMpTmp.gen_Tab_Valid_Cd;
        this.dprm_Tab_Valid_Cd = dxMpTmp.dprm_Tab_Valid_Cd;
        this.sprm_Tab_Valid_Cd = dxMpTmp.sprm_Tab_Valid_Cd;
        this.multiSourceFlg = dxMpTmp.multiSourceFlg;
        this.dataConnectService_Id = dxMpTmp.dataConnectService_Id;
        this.dataConnectService_Nm = dxMpTmp.dataConnectService_Nm;

    }

    compare(dxMpTmp: DxMp): string {
        let dxMpString: string = this.toString(false);
        let dxMpTmpString: string = dxMpTmp.toString(false);

        if (dxMpString != dxMpTmpString) {
            return dxMpString + ', ' + dxMpTmpString
        }

        return "";
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DxMp [dxMp_Id=" + this.dxMp_Id + ", layer_Id=" + this.layer_Id + ", nm=" + this.nm +
            ", description=" + this.description + ", ver=" + this.ver + ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
            ", reusableFlag=" + this.reusableFlag + ", valid_Cd=" + this.valid_Cd +
            ", conn_Id=" + this.conn_Id + ", conn_Nm=" + this.conn_Nm + ", debugFlg=" + this.debugFlg +
            ", conn_Fldr_Id=" + this.conn_Fldr_Id + ", tform_Valid_Cd=" + this.tform_Valid_Cd +
            ", streamingFlg=" + this.streamingFlg + ", spark_dsa=" + this.spark_dsa + ", type=" + this.type +
            ", gen_Tab_Valid_Cd=" + this.gen_Tab_Valid_Cd + ", dprm_Tab_Valid_Cd=" + this.dprm_Tab_Valid_Cd +
            ", sprm_Tab_Valid_Cd=" + this.sprm_Tab_Valid_Cd + ", multiSourceFlg=" + this.multiSourceFlg +
            ", dataConnectService_Id =" + this.dataConnectService_Id;

        if (isNotCompare) {
            str += ", updateBy=" + this.updateBy + ", lastUpdateBy=" + this.lastUpdateBy + ", updateDt=" + this.updateDt +
                ", change_Ind=" + this.change_Ind + ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
                ", dataConnectService_Nm =" + this.dataConnectService_Nm;
        }

        str += ']';
        return str;
    }
}